export default "__VITE_ASSET__ddRwNQ84__"